import React from "react";
import { connect } from "react-redux";
import { RewardCheckCodeContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import * as XLSX from "xlsx";
import moment from "moment";
import momentTZ from "moment-timezone";
import { toast } from "react-toastify";
import queryString from "query-string";
import { ROUTE_PATH } from "utils/constants/routePath";
import { REDER_REWARD_E_VOUCHER_STATUS } from "utils/functions/reward";
import { EVoucherAddToCusWidget } from "widgets";
import { Buttons, Displays, Inputs, Modals, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class RewardCheckCodeContainer extends React.Component {
  state = {
    isLoading: true,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (queryString) => {
    let res = await portalService.GET_REWARD_E_VORCHER(queryString);
    if (res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoadingTable: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.REWARD_CHECK_CODE}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickGifgPoint = async (e) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      customer_id: e.customer_ref_id,
      activity_id: e.activity_ref_id,
      activity_history_id: e._id,
    };
    let res = await portalService.POST_REWARD_HITORY_SCAN(params);
    if (res && res.status === 200) {
      this.fetchData();
    } else {
      toast.error("ไม่สำเร็จ");
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  handleExport = async () => {
    const { data } = this.state;
    this.setState({ isBgLoading: true });
    try {
      const wb = XLSX.utils.book_new();
      const ws_name = "Reward Data";
      const ws_data = data?.docs?.map((item, index) => [
        index + 1,
        momentTZ(item.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
        item?.member_detail
          ? `${item.member_detail.first_name} ${item.member_detail.last_name}`
          : "-",
        item?.phone || "-",
        item?.used_by || "-",
        item?.redeemed || "-",
        item?.time_to_use || "-",
        item?.used || "-",
        item?.used_date_1
          ? momentTZ(item.used_date_1)
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm")
          : "-",
        item?.used_date_2
          ? momentTZ(item.used_date_2)
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm")
          : "-",
        item?.used_date_3
          ? momentTZ(item.used_date_3)
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm")
          : "-",
        item?.instrument || "-",
        item?.sn || "-",
      ]);

      // Header row
      ws_data.unshift([
        "No",
        "Redeem Date",
        "Name",
        "Phone",
        "Used By",
        "Redeemed",
        "Time to use",
        "Used",
        "Used Date 1",
        "Used Date 2",
        "Used Date 3",
        "Instrument",
        "S/N",
      ]);

      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      ws["!cols"] = [
        { wch: 5 },
        { wch: 20 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      XLSX.writeFile(
        wb,
        `reward-export-${moment().format("YYYYMMDD_HHmmss")}.xlsx`
      );
    } catch (err) {
      toast.error("Export failed!");
      console.error(err);
    }
    this.setState({ isBgLoading: false });
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, data, pagination, renderModal } =
      this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <RewardCheckCodeContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="block_section">
          <div className="title">Check Code and Redeemer</div>
        </div>
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="body_table">
              <Tables.Standard
                columns={columns({
                  permission: permission,
                  onSuccess: this.fetchData,
                })}
                data={data.docs}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
            <div className="btn_wrap">
              <div className="w120">
                <Buttons.BgStandard label="Back" onClick={this.handleCancel} />
              </div>
            </div>
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RewardCheckCodeContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "code",
      length: "311px",
      filter: {
        fieldQuery: "code",
        defaultValue: initialValues["code"],
        type: "text",
        label: "Code",
        placeholder: "Code",
      },
    },
    {
      accessor: "cus_name",
      length: "311px",
      filter: {
        fieldQuery: "cus_name",
        defaultValue: initialValues["cus_name"],
        type: "text",
        label: "Name",
        placeholder: "Name",
      },
    },
    {
      accessor: "phone_number",
      length: "311px",
      filter: {
        fieldQuery: "phone_number",
        defaultValue: initialValues["phone_number"],
        type: "text",
        label: "Phone",
        placeholder: "",
      },
    },
    {
      accessor: "status",
      length: "311px",
      filter: {
        fieldQuery: "status",
        defaultValue: initialValues["status"],
        type: "dropdown",
        label: "Status",
        placeholder: "All",
        options: [
          {
            label: "Active/ ready to use",
            value: "1",
          },
          {
            label: "Redeemed",
            value: "2",
          },
          {
            label: "Used",
            value: "3",
          },
          {
            label: "Expired",
            value: "4",
          },
        ],
      },
    },
  ];
};

const columns = ({ permission, onSuccess }) => {
  let temp = [
    {
      Header: <div style={{ textAlign: "left" }}>Reward Code</div>,
      accessor: "reward_code",
    },
    {
      Header: <div style={{ textAlign: "left" }}>Code</div>,
      accessor: "code",
    },
    {
      Header: <div style={{ textAlign: "left" }}>Status</div>,
      accessor: "status",
      Cell: (props) => REDER_REWARD_E_VOUCHER_STATUS(props.value),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Name</div>,
      accessor: "first_name",
      Cell: (props) => (
        <div>
          {!props.value
            ? "-"
            : `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: props.value,
              })}`}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Last Name</div>,
      accessor: "last_name",
      Cell: (props) => (
        <div>
          {!props.value
            ? "-"
            : `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: props.value,
              })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: props.row.original?.member_detail?.last_name,
              })}`}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Phone</div>,
      accessor: "phone_number",
      Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Time to use</div>,
      accessor: "time_to_use",
      Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Used</div>,
      accessor: "used",
      Cell: (props) => <div>{!props.value ? 0 : `${props.value}`}</div>,
    },

    // {
    //   Header: <div style={{ textAlign: "left" }}>Used Date 1</div>,
    //   accessor: "used_date_1",
    //   Cell: (props) => (
    //     <div>
    //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
    //     </div>
    //   ),
    // },
    // {
    //   Header: <div style={{ textAlign: "left" }}>Used Date 2</div>,
    //   accessor: "used_date_2",
    //   Cell: (props) => (
    //     <div>
    //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
    //     </div>
    //   ),
    // },
    // {
    //   Header: <div style={{ textAlign: "left" }}>Used Date 3</div>,
    //   accessor: "used_date_3",
    //   Cell: (props) => (
    //     <div>
    //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
    //     </div>
    //   ),
    // },
    {
      Header: <div style={{ textAlign: "left" }}>Instrument</div>,
      accessor: "instrument",
      Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>S/N</div>,
      accessor: "sn",
      Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Add To Customer</div>,
      accessor: "add_to_customer",
      Cell: (props) =>
        props.row.original.status === "1" && (
          <div style={{ textAlign: "center" }}>
            <EVoucherAddToCusWidget
              reward_id={props.row.original.reward_ref_id}
              reward_e_voucher_id={props.row.original._id}
              onSuccess={onSuccess}
            />
          </div>
        ),
    },
  ];
  return temp;
};

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RewardCheckCodeContainer));
